import FlexPane from './_flex-pane.js'
import Button from './_button.js'
import Text from './_text.js'
import EventTimingStatus from './_event-timing-status.js'
import EventListItemDetails from './_event-list-item-details.js'
import EventListMarketsSection from './_event-list-markets-section.js'
import GenericMarketContent from './_generic-market-content.js'
import GameLineMarketContent from './_game-line-market-content.js'
import ImageButton from './_image-button.js'

export default {
  name: 'EventListItem',
  values: {
    hideMoreMarketsButton: true,
    _mobile_hideMoreMarketsButton: false,
    reportLoadingStatus: false,
    container: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
        },
      },
    },
    detailsContainer: {
      configSet: FlexPane,
      configValues: {},
    },
    outrightClickableArea: {
      configSet: Button,
      configValues: {
        style: {
          base: {
            minHeight: '50px',
            alignItems: 'center',
          },
        },
      },
    },
    eventNameLabel: {
      configSet: Text,
      configValues: {
        truncate: true,
        ellipsisOnLineNumber: 2,
        container: {
          padding: '0 8px 0 0',
        },
      },
    },
    eventDetailsRow: {
      configSet: EventTimingStatus,
      configValues: {
        container: {
          style: {
            base: {
              minHeight: '24px',
            },
          },
        },
      },
    },
    itemDetails: {
      configSet: EventListItemDetails,
      configValues: {},
    },
    itemDetailsGameLine: {
      configSet: EventListItemDetails,
      configValues: {
        participants: {
          showSeparator: true,
          container: {
            style: {
              minHeight: '85px',
            },
          },
          text: {
            ellipsisOnLineNumber: 2,
          },
        },
      },
    },
    marketsSectionContainer: {
      configSet: EventListMarketsSection,
      configValues: {
        container: {
          style: {
            flexGrow: 0,
            flexShrink: 0,
            minHeight: '50px',
          },
        },
      },
    },
    fallbackMarketNameContainer: {
      configSet: EventListMarketsSection,
      configValues: {
        container: {
          itemSpacing: '0',
          style: {
            justifyContent: 'center',
            flexGrow: 0,
            flexShrink: 0,
          },
        },
      },
    },
    fallbackMarketName: {
      configSet: Text,
      configValues: {
        truncate: true,
        container: {
          flexGrow: 0,
        },
        style: {
          textAlign: 'center',
        },
      },
    },
    fallbackMarketNameEndingInfo: {
      configSet: Text,
      configValues: {
        container: {
          flexShrink: 0,
          flexGrow: 0,
        },
      },
    },
    fallbackMarketNameDelimiter: '(',
    fallbackMarketContent: {
      configSet: GenericMarketContent,
      configValues: {
        container: undefined,
        layoutDescriptors: {
          default: {
            selectionNameDisplay: 'show short',
          },
          categories: {
            OVER_UNDER: {
              _mobile_selectionNameDisplay: 'show shortest',
            },
          },
        },
      },
    },
    headerContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          alignItems: 'center',
        },
      },
    },
    genericMarketContent: {
      configSet: GenericMarketContent,
      configValues: {
        container: {
          style: {
            padding: 0,
            flexBasis: '100%',
          },
        },
        market: {
          selectionButton: {
            view: {
              layoutDirection: 'vertical',
              nameDisplay: 'hide',
              _mobile_nameDisplay: 'hide',
            },
          },
        },
      },
    },
    gameLineMarketContent: {
      configSet: GameLineMarketContent,
      configValues: {
        showParticipants: false,
        showMarketHeaders: false,
        container: {
          style: {
            padding: 0,
          },
        },
      },
    },
    moreMarketsButton: {
      configSet: ImageButton,
      configValues: {
        button: {
          style: {
            base: {
              justifyContent: 'flex-end',
            },
          },
        },
        innerContainer: {
          style: {
            flexGrow: 0,
            minWidth: '90px',
            flexDirection: 'row-reverse',
            alignItems: 'baseline',
          },
        },
        buttonIcon: {
          src: 'chevron-right',
          style: {
            minWidth: '16px',
            minHeight: '8px',
          },
        },
        buttonLabel: {
          container: {
            flexGrow: 0,
          },
        },
      },
    },
    marketCountButton: {
      configSet: ImageButton,
      configValues: {
        button: {
          style: {
            base: {
              justifyContent: 'flex-start',
              padding: '4px 0',
            },
          },
        },
        innerContainer: {
          style: {
            flexGrow: 0,
            flexDirection: 'row-reverse',
            alignItems: 'baseline',
          },
        },
        buttonIcon: {
          src: 'chevron-right',
          style: {
            minWidth: '16px',
            minHeight: '8px',
          },
        },
        buttonLabel: {
          truncate: true,
          container: {
            flexGrow: 0,
          },
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
